<script>
import TheDrawerMinifier from '@components/layout/the-drawer-minifier.vue'
import baseMixin from '@/mixins/baseMixin'
import navMixin from '@/mixins/navMixin'
import { mapGetters } from 'vuex'
import LogoForm from '@/constants/assets/LogoForm'
import TheAppLogo from './the-app-logo.vue'

export default {
  name: 'TheNavDrawer',
  components: {
    TheDrawerMinifier,
    TheAppLogo,
  },
  mixins: [baseMixin, navMixin],
  props: {
    drawer: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    isMini() {
      return !this.isMediumOrLower && this.mini
    },
    compLogoForm() {
      return this.isMini ? LogoForm.ICON : LogoForm.NONE
    },
    compLogoWidth() {
      return this.isMini ? '25' : '120'
    },
  },
  methods: {
    handleDrawer(event) {
      if (this.isMediumOrLower) return this.$emit('setDrawerState', event)
    },
    convertToActiveIcon(icon) {
      const strSplit = icon.split('-outline')
      return strSplit[0]
    },
  },
}
</script>

<template>
  <v-navigation-drawer
    id="main-navigation-drawer"
    app
    :hide-overlay="!isMediumOrLower"
    :value="drawer"
    bottom
    floating
    :temporary="isMediumOrLower"
    :mini-variant="isMini"
    disable-route-watcher
    :class="['nav-drawer--border sidebar']"
    @input="handleDrawer($event)"
  >
    <v-list flat class="sidebar-nav primary--text">
      <div v-for="{ icon, title, to, key, preview } in navItems" :key="key">
        <v-tooltip :disabled="!isMini" right>
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="to"
              :title="!isMini ? title : ''"
              :aria-label="title"
              link
              exact
              color="primary"
              v-on="on"
            >
              <v-list-item-icon>
                <BaseIcon
                  :color="isActiveNavItem(to) ? 'primary' : ''"
                  :name="isActiveNavItem(to) ? convertToActiveIcon(icon) : icon"
                ></BaseIcon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  :class="[
                    'text-subtitle-2',
                    isActiveNavItem(to)
                      ? 'font-weight-bold'
                      : 'font-weight-medium',
                  ]"
                >
                  {{ title }}
                  <span
                    v-if="preview"
                    style="
                      font-size: 0.5em;
                      font-weight: 200;
                      text-transform: uppercase;
                    "
                    >Preview</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ title }}</span>
        </v-tooltip>
      </div>
    </v-list>
    <template v-slot:prepend>
      <div style="height: 72px" class="d-flex align-center justify-center">
        <TheAppLogo :width="compLogoWidth" :form="compLogoForm" />
      </div>
    </template>
    <template v-if="!isMediumOrLower" v-slot:append>
      <TheDrawerMinifier />
    </template>
  </v-navigation-drawer>
</template>

<style lang="scss" scoped>
.nav-drawer--border {
  border-right: 1px solid rgb(0 0 0 / 12%) !important;
}
</style>
